// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"689":"b536a0f1","870":"bd904a5c"}[chunkId] || chunkId) + "." + {"397":"1e8fbe17177466a4","689":"6bbd873ddbca4b87","870":"ba5cf43f569aad87"}[chunkId] + ".js";
};